import { Popover } from 'react-tiny-popover';
import MoreIcon from '../../../../../assets/icons/more.svg?react';
import { useState } from 'react';
import { IoTrash } from 'react-icons/io5';
import { Menu, Item } from './style';

export default function RowAction({ onDelete }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = e => {
    e?.preventDefault();
    e?.stopPropagation();

    setIsOpen(prev => !prev);
  };

  const handleDelete = e => {
    e?.preventDefault();
    e?.stopPropagation();
    toggle();
    onDelete();
  };

  return (
    <Popover
      padding={10}
      isOpen={isOpen}
      onClickOutside={toggle}
      positions={['bottom']}
      transitionDuration={300}
      content={
        <Menu>
          <Item onClick={handleDelete} className="danger">
            <IoTrash />
            Delete
          </Item>
        </Menu>
      }
    >
      <button onClick={toggle} data-testid="RowAction">
        <MoreIcon />
      </button>
    </Popover>
  );
}
